import { LANGUAGE_KEYS } from 'config/languageKeys';

import { CachedRecordingItem } from 'store/recordings/reducer.types';

import { EventParentalControlRating } from 'services/data-manager/types';

export enum EpgProgramIcon {
    NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
    REPLAY_SO = 'REPLAY_SO',
    REPLAY_CU = 'REPLAY_CU',
}

export type EpgProgramExtra = {
    testID: string;
    iconTestID: string;
    time: string;
    subscribed: boolean;
    minimizedCell: boolean;
    isFirstCell: boolean;
    isLastCell: boolean;
    iconType: EpgProgramIcon | undefined;
    rating?: EventParentalControlRating;
    recordingItem: CachedRecordingItem | undefined;
    originalTitle: string;
};

export type EpgChannelExtra = {
    subscribed: boolean;
};

export type EpgFilterCategory = {
    key: keyof typeof LANGUAGE_KEYS.EPG.FILTER_CATEGORIES;
    label: string;
    isSelected: boolean;
};
